import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

function ProtectedRoute({children}) {
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
    useEffect(() =>{
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    const expiryTime = localStorage.getItem("expiryTime");
    const currentTime = new Date().getTime();
    console.log("Checked...")
    if(!userId && !token) {
        navigate("/login")
        setShowPopup(false);
        return;
    }
    if (expiryTime && currentTime > Number(expiryTime)) {
        localStorage.clear();
        setShowPopup(true);
    }
    },[navigate]);

    const handleOk = () => {
        setShowPopup(false);
        navigate("/login")
    } 
    return (
        <>
        <Dialog header="Session Expired" visible={showPopup} closable={false} modal style={{width: '25rem'}}>
          <p>Your session has expired. Please login again.</p>
          <div className='flex justify-content-end mt-4'>
            <Button label="OK" onClick={handleOk}/>
          </div>
         </Dialog>
         {!showPopup && children}
        </>
        );
}

export default ProtectedRoute;